import * as yup from 'yup';

const reassignPayCalendarSchema = yup.object().shape({
  targetPayCalendarId: yup.string().required('Target pay calendar is required'),
  employmentType: yup
    .string()
    .oneOf(['SALARIED', 'NON_SALARIED'])
    .required('Employment type is required'),
  annualGrossSalary: yup.string().notRequired(),
});

export default reassignPayCalendarSchema;
